import youTubeSrc from '@arelia-assets/youtube.png';
import facebookSrc from '@arelia-assets/facebook.png';
import instagramSrc from '@arelia-assets/instagram.png';
import spotifySrc from '@arelia-assets/spotify.png';
import distrokidSrc from '@arelia-assets/distrokid.png';
import areliaSrc from '@arelia-assets/arelia.png';
import songtrustSrc from '@arelia-assets/songtrust.png';
import tiktokSrc from '@arelia-assets/tiktok.svg';
import twitterSrc from '@arelia-assets/twitter.png';
import { ConnectionName } from '@arelia-types/connection';

export default function getConnectionIcon(name: ConnectionName) {
  switch (name) {
    case ConnectionName.youtube:
      return youTubeSrc;
    case ConnectionName.facebook:
      return facebookSrc;
    case ConnectionName.instagram:
      return instagramSrc;
    case ConnectionName.spotify:
      return spotifySrc;
    case ConnectionName.distrokid:
      return distrokidSrc;
    case ConnectionName.arelia:
      return areliaSrc;
    case ConnectionName.songtrust:
      return songtrustSrc;
    case ConnectionName.tiktok:
      return tiktokSrc;
    case ConnectionName.twitter:
      return twitterSrc;
    default:
      return '';
  }
}
